import { render, staticRenderFns } from "./BloquearAsientosNormales.vue?vue&type=template&id=a2119332"
import script from "./BloquearAsientosNormales.vue?vue&type=script&setup=true&lang=js"
export * from "./BloquearAsientosNormales.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports